import "core-js/modules/es6.object.freeze";
import "core-js/modules/es7.array.includes";
import devError from '../utilities/dev-error';
import units from './units';
import { Font, Weight } from '../types/text';
var TEXT_SIZES = [-2, -1, 0, 1, 2, 3, 4, 5, 6, 12];
export var BOLD = 700;
export var MEDIUM = 500;
export var NORMAL = 400;
var typeScaleRootPx = 16;
var typeScaleRoot = '16px';

var getFont = function getFont(type) {
  if (type === void 0) {
    type = Font.Body;
  }

  switch (type) {
    case Font.Title:
    case Font.Body:
    default:
      return "'America', sans-serif";
  }
};

var getFontRefresh = function getFontRefresh(type) {
  if (type === void 0) {
    type = Font.Body;
  }

  switch (type) {
    case Font.Title:
      return 'Walsheim, sans-serif';

    case Font.Body:
    default:
      return 'aktiv-grotesk, sans-serif';
  }
};

var getLineHeight = function getLineHeight(size) {
  return size < 2 ? 1.5 : 1.25;
};

var getMargin = function getMargin(el) {
  switch (el) {
    case 'p':
      return units.getValues([1, 0]) + " !important";

    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return '1em 0 !important';

    default:
      return '0';
  }
};

var getSizeRem = function getSizeRem(i) {
  var TYPE_RATIO = 1.618;
  var TYPE_BASE1 = 1; // rem

  var TYPE_BASE2 = TYPE_BASE1 * (1 + TYPE_RATIO) / 2;

  if (!TEXT_SIZES.includes(i)) {
    devError("Invalid text size. Expected an integer between " + TEXT_SIZES[0] + " and\n " + TEXT_SIZES[TEXT_SIZES.length - 1] + ", got: " + i);
    return;
  }

  var base = Math.abs(i % 2) === 1 ? TYPE_BASE1 : TYPE_BASE2;
  return base * Math.pow(TYPE_RATIO, Math.ceil(i / 2.0) - 1);
};

var getSizeRemRefresh = function getSizeRemRefresh(i) {
  switch (i) {
    case 6:
      return 3.5;
    // 56px

    case 5:
      return 2.625;
    // 42px

    case 4:
      return 2.125;
    // 34px

    case 3:
      return 1.625;
    // 26px

    case 2:
      return 1.3125;
    // 21px

    case 1:
    default:
      return 1;
    // 16px

    case 0:
      return 0.875;
    // 14px

    case -1:
      return 0.625;
    // 10px
  }
};

var getSizePx = function getSizePx(i) {
  return getSizeRem(i) * typeScaleRootPx;
};

var getSizePxRefresh = function getSizePxRefresh(i) {
  return getSizeRemRefresh(i) * typeScaleRootPx;
};

var getSize = function getSize(i) {
  return getSizeRem(i) + "rem !important;";
};

var getSizeRefresh = function getSizeRefresh(i) {
  return getSizeRemRefresh(i) + "rem !important;";
};

var getWeight = function getWeight(weight) {
  switch (weight) {
    case Weight.Bold:
    case Weight.Medium:
      return BOLD;

    case Weight.Normal:
    default:
      return NORMAL;
  }
};

var getWeightRefresh = function getWeightRefresh(weight, font) {
  if (font === void 0) {
    font = Font.Body;
  }

  if (font === Font.Title) {
    return BOLD;
  }

  switch (weight) {
    case Weight.Bold:
      return BOLD;

    case Weight.Medium:
      return MEDIUM;

    case Weight.Normal:
    default:
      return NORMAL;
  }
};

var tracking = {
  normal: 'normal',
  wide: '0.1em'
};
export var text = Object.freeze({
  getFont: getFont,
  getLineHeight: getLineHeight,
  getMargin: getMargin,
  getSize: getSize,
  getSizePx: getSizePx,
  getSizeRem: getSizeRem,
  getWeight: getWeight,
  tracking: tracking,
  typeScaleRoot: typeScaleRoot
});
export var textRefresh = Object.freeze({
  getFont: getFontRefresh,
  getLineHeight: getLineHeight,
  getMargin: getMargin,
  getSize: getSizeRefresh,
  getSizePx: getSizePxRefresh,
  getSizeRem: getSizeRemRefresh,
  getWeight: getWeightRefresh,
  tracking: tracking,
  typeScaleRoot: typeScaleRoot
});